import { LOGO_SVG } from './logo.generated';

// The logo, inlined wherever it appears (headers, sidebar) so it costs no request. Its geometry and every
// file made from it live in packages/shared/brand (npm run brand).
export const MARK_SVG = LOGO_SVG;
export { LOGO_GEOMETRY } from './logo.generated';

export const SITE_NAME = 'Math Ladder';
